import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ExternalRedirectGuard implements CanActivate {
  canActivate(): boolean {
    window.location.href = 'https://www.rejsebillet.dk/da-dk/faa-hjaelp/specialbilletter';
    return false;
  }
}
